<div id="layout-config" *ngIf="!buttonConfig?.hideExportButton" class="layout-config " [ngClass]="{'layout-config-active': appMain.configActive}"
    (click)="appMain.onConfigClick($event)">
    <a id="gridConfigButton" class="layout-config-button" href="javascript:;" pTooltip="Additional Options"
        tooltipPosition="left" class="layout-config-button fab-button" (click)="onConfigButtonClick($event)">
        <i class="pi pi-ellipsis-v fab-button-icon ellip"></i>
    </a>
    <div class="layout-config-content">
        <p-panelMenu [model]="items" styleClass="w-100"></p-panelMenu>
    </div>
</div>
<!-- <a class="float-column-settings" tooltipPosition="top"><button pButton pRipple type="button" *ngIf="!router.url.includes('/user/record/tracker')"
    icon="fas fa-sliders-v" class="p-button-rounded round-icon-button"
    pTooltip="View Column Settings"  (click)="onClickShowColumnSettingsModal()"></button></a> -->
<span *ngIf="!buttonConfig?.hideFilterButton ">
<app-sidebar-filter *ngIf="grid_schema?.length>0" (clearFilterModel)="clearFilterModel()" (populateFiter)="populateFilterTemplateData($event)" [module_id]="module_id" [documentFieldList]="documentFieldList" [showFilterTemplate]="buttonConfig?.showFilterTemplate" [showSaveFilterTemplate]="buttonConfig?.showFilterTemplateCreate"  [showDeleteTemplate]="buttonConfig?.showDeleteTemplate"  [grid_schema]="grid_schema" [showFilter]="showFilter" (applyFilter)="onClickFilter($event)" (resetFilter)="onClickReset()"
    (toggleFilter)="showFilter = !showFilter" [filterModel]="filterModel"  (dateSelectFilter)="onDateSelect($event)"  (closeSidebar)="closeSidebar()">
</app-sidebar-filter>
</span>
<p-table #dt [value]="data" dataKey="id" [scrollable]="true" class="test-data" styleClass="p-datatable-sm "
    [showCurrentPageReport]="true" [paginator]="false" [columns]="grid_schema" [loading]="loading" [lazy]="true"
    (onLazyLoad)="sortColumn($event)" [sortField]="default_order_by" [sortOrder]="order_type" [responsive]="true">
    <ng-template pTemplate="header">
        <tr>
            <th class="action" pFrozenColumn >Actions <br></th>
            <th [ngStyle]="{'min-width': col?.width + 'px'}" *ngFor="let col of grid_schema"
                [pSortableColumn]="col?.key" [pSortableColumnDisabled]="!col.is_sortable">
                <div [ngSwitch]="col?.label">
                    <span *ngSwitchDefault>{{col?.label}}
                        <p-sortIcon *ngIf="col?.is_sortable" field="{{col?.key}}"></p-sortIcon>
                    </span>
                </div>
            </th>
        </tr>
        <tr class="filterRow" *ngIf="!buttonConfig?.hideFilterButton">
            <th style="max-width: 115px; height: 41px;" class="flex align-items-center" pFrozenColumn>
                <button (click)="onClickReset()" pButton class="text-button link-button p-0 px-1 m-0" pTooltip="RESET"> <i class="pi pi-filter-slash"></i></button>
                <button (click)="onClickFilter()" [disabled]="!hasFilterValues()" pButton pTooltip="APPLY" class="text-button link-button p-0 px-1 m-0"><i class="fa fa-filter"></i></button>
            </th>
            <th [ngStyle]="{'min-width': col?.width + 'px'}" *ngFor="let col of grid_schema">
                <div [ngSwitch]="col?.filter_type" class="w-12" *ngIf="col?.is_filterable">
                    <span *ngSwitchCase="'dropdown'">
                        <p-columnFilter [field]="col?.key" matchMode="in" [showMenu]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <span class="flex justify-content-start align-items-center">
                                        <p-dropdown  #dropdown  [options]="col?.filter_options" optionLabel="name" optionValue="value"
                                        [ngStyle]="{ 'max-width': col?.width + 'px','min-width': col?.width + 'px'}" [autoDisplayFirst]="false" [resetFilterOnHide]="true"
                                        [(ngModel)]="filterModel[col?.key]" [showClear]="true" appendTo="body"  [filter]="true" [virtualScroll]="true"
  [itemSize]="35"
  [scrollHeight]="getScrollHeight(col?.filter_options)"
>
                                        <ng-template let-itm pTemplate="selectedItem">
                                            <div style="display: grid; grid-template-columns: auto 20% 20%;">
                                              <span style="text-align: left">{{itm.name}}</span>
                                            </div>
                                          </ng-template>
                                           <ng-template let-item pTemplate="item">
            <div class="flex align-items-center gap-2" [pTooltip]="item?.name">
                <div>{{ item?.name }}</div>
            </div>
        </ng-template>
                                          <!-- <ng-template pTemplate="footer">
                                            <span class="flex justify-content-center p-2">
                                                <button pButton label="APPLY"
                                                    class="sidebar-button cozmos-primary-button"
                                                    (click)="onClickApplyOptionsFilter(dropdown)"></button>
                                                <button pButton label="CLEAR"
                                                    class="sidebar-button cozmos-secondary-button ml-2"
                                                    (click)="onClickClearOptionsFilter(dropdown,col?.key)"></button>
                                            </span>
                                        </ng-template> -->
                                        </p-dropdown>
                                </span>
                            </ng-template>
                        </p-columnFilter>
                    </span>
                    <span *ngSwitchCase="'multiselect'">
                        <p-columnFilter [field]="col?.key" matchMode="in" [showMenu]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <span class="flex justify-content-start align-items-center">
                                    <p-multiSelect display="chip" #multiselect [options]="col?.filter_options" optionLabel="name" optionValue="value"
                                    [ngStyle]="{ 'max-width': col?.width + 'px','min-width': col?.width + 'px'}"  [filter]="true" [pTooltip]="value"
                                        styleClass="w-12" [autoDisplayFirst]="false" [resetFilterOnHide]="true" [virtualScroll]="true"
  [itemSize]="35"
  [scrollHeight]="getScrollHeight(col?.filter_options)"
                                        [(ngModel)]="filterModel[col?.key]" [showClear]="true" appendTo="body">
                                                                                   <ng-template let-item pTemplate="item">
            <div class="flex align-items-center gap-2" [pTooltip]="item?.name">
                <div>{{ item?.name }}</div>
            </div>
        </ng-template>
                                        <ng-template pTemplate="footer">
                                            <span class="flex justify-content-center p-2">
                                                <button pButton label="APPLY"
                                                    class="sidebar-button cozmos-primary-button"
                                                    (click)="onClickApplyOptionsFilter(multiselect)"></button>
                                                <button pButton label="CLEAR"
                                                    class="sidebar-button cozmos-secondary-button ml-2"
                                                    (click)="onClickClearOptionsFilter(multiselect,col?.key)"></button>
                                            </span>
                                        </ng-template>
                                    </p-multiSelect>
                                </span>
                            </ng-template>
                        </p-columnFilter>
                    </span>
                    <span *ngSwitchCase="'radiobutton'">
                        <p-columnFilter [field]="col?.key" matchMode="in" [showMenu]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <span class="flex justify-content-start align-items-center">
                                    <div *ngFor="let category of col?.filter_options" class="w-12">
                                        <p-radioButton [inputId]="category.value" name="category"
                                            [value]="category?.value"
                                            [(ngModel)]="filterModel[col?.key]"></p-radioButton>
                                        <label [for]="category.value">{{category.name}}</label>
                                    </div>

                                </span>
                            </ng-template>
                        </p-columnFilter>
                    </span>
                    <span *ngSwitchCase="'calendar'">
                        <p-columnFilter [field]="col?.key" matchMode="in" [showMenu]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <span class="flex justify-content-start align-items-center">
                                    <p-calendar appendTo="body" tooltipPosition="left"
                                        [(ngModel)]="filterModel[col?.key]" [hideOnDateTimeSelect]="true"
                                        selectionMode="range" [showIcon]="true" showClear="true"
                                        (ngModelChange)="onDateSelectGrid($event, col?.key)" showButtonBar="true"
                                        [readonlyInput]="true">
                                    </p-calendar>
                                </span>
                            </ng-template>
                        </p-columnFilter>
                    </span>
                    <span *ngSwitchDefault [pTooltip]="document?.[col.key]">
                        <p-columnFilter [field]="col?.key" matchMode="in" [showMenu]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <span class="flex justify-content-start align-items-center">
                                    <input pInputText type="text" class="w-12" [(ngModel)]="filterModel[col?.key.endsWith('_by') ? col.key.replace('_by', '_by_name') : col.key]"
                                        (keyup.enter)="onClickFilter()">
</span>
                            </ng-template>
                        </p-columnFilter></span>
                </div>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-document>
        <tr [pSelectableRow]="document">
            <td style="max-width: 115px;" class="flex gap-1" pFrozenColumn>
                <button *ngIf="buttonConfig?.showCopyConfigButton" pButton type="button"
                class="p-button-text action-button" pTooltip="Copy"
                id="{{'doc-details'+document?.id}}" (click)="onClickCopy(document,document?.id)"
                aria-label="doc-field-details" tooltipPosition="top" icon="fas fa-copy"></button>
                <button *ngIf="buttonConfig?.showEditButton" pButton type="button" class="p-button-text action-button"
                    pTooltip="Edit" id="{{'doc-details'+document?.id}}" aria-label="doc-details" tooltipPosition="top"
                    icon="fas fa-edit" (click)="onClickEdit(document,document?.id)"></button>
                <button *ngIf="buttonConfig?.showDeleteButton" pButton type="button" class="p-button-text action-button"
                    (click)="onClickDelete(document?.id)" pTooltip="Delete" id="{{'doc-details'+document?.id}}"
                    aria-label="doc-details" tooltipPosition="top" icon="fas fa-trash"></button>
                    <div *ngIf="buttonConfig?.showViewRecordButton" class="flex align-items-center">
                        <span pTooltip="{{ document?.view_ticket ? 'View' : 'SSC privilege missing' }}" tooltipPosition="top">
                        <button (click)="onClickViewPDF(document)" pButton type="button"
                            class="p-button-text action-button" [disabled]="!document?.view_ticket" [attr.id]="'doc-details' + document?.id"
                            aria-label="doc-details" icon="fas fa-external-link-alt">
                        </button>
                    </span>
                    </div>
                    <button *ngIf="buttonConfig?.showViewVendorButton" (click)="onClickVendorView(document?.id)" pButton type="button"
                        class="p-button-text action-button" pTooltip="View" [attr.id]="'doc-details' + document?.id"
                        aria-label="doc-details" tooltipPosition="top" icon="fas fa-eye" [disabled]="!document?.view_ssc_privilege"
                        [ngClass]="{ 'disabled-eye': !document?.view_ssc_privilege }">
                    </button>
                    <div *ngIf="buttonConfig?.showLob" class="flex align-items-center">
                        <span pTooltip="{{ !document?.vendor_master_data?.length ? 'No Supplier Map Data' : 'View Supplier Map Data' }}"
                            tooltipPosition="top">
                            <button (click)="vendorMapDataToggle.toggle($event); onClickViewVendorMapData(document)"
                                [disabled]="!document?.vendor_master_data?.length" pButton type="button" class="p-button-text action-button"
                                [attr.id]="'doc-details' + document?.id" aria-label="doc-details" icon="fas fa-share">
                            </button>
                        </span>
                    </div>
                    <button *ngIf="buttonConfig?.showLog" (click)="onClickViewD365Log(document?.legal_entity, document?.account_number)"
                        pButton type="button" class="p-button-text action-button" pTooltip="View D365 Logs" [disabled]="!document?.view_ssc_privilege"
                        [attr.id]="'doc-details' + document?.id" aria-label="view-d365-log" tooltipPosition="top" [ngClass]="{ 'disabled-eye': !document?.view_ssc_privilege }"
                        icon="fas fa-calendar-alt">
                    </button>
                    <button *ngIf="buttonConfig?.showTicketLog" (click)="onClickViewD365TicketLog(document?.legal_entity, document?.account_number)"
                        pButton type="button" class="p-button-text action-button" pTooltip="View Ticket Logs"
                        [attr.id]="'doc-details' + document?.id" aria-label="view-d365-log" tooltipPosition="top"
                         icon="fas fa-list">
                    </button>
                <div *ngIf="buttonConfig?.showRedirectVendor" class="flex align-items-center">
                    <span pTooltip="{{ !document?.source_id ? 'No D365 Data' : 'View D365 Database' }}" tooltipPosition="top">
                        <button (click)="onClickViewVendor(document)" [disabled]="!document?.source_id" pButton type="button"
                            class="p-button-text action-button" [attr.id]="'doc-details' + document?.id" aria-label="doc-details"
                            icon="fas fa-share">
                        </button>
                    </span>
                </div>
                    <button *ngIf="buttonConfig?.showAssignButton" pButton (click)="onClickAssignUser(document)"
                    type="button" class="p-button-text action-button" [pTooltip]="document?.assigned_to?'Re-Assign (Ticket is already assigned to '+document?.assigned_to+')':'Assign'"
                    id="{{'doc-details'+document?.id}}" aria-label="doc-details" tooltipPosition="top"
                    icon="fas fa-user-plus"></button>
                    <button *ngIf="buttonConfig?.showEmailControllerButton" (click)="onClickController(document)" pButton type="button"
                        class="p-button-text action-button" pTooltip="View Email Controller" aria-label="controller-action"
                        tooltipPosition="top" icon="fa fa-envelope">
                    </button>
                    <!-- <button *ngIf="buttonConfig?.showRejectButton" pButton (click)="onClickCancelUser(document)"
                    type="button" class="p-button-text action-button" pTooltip="Reject"
                    id="{{'doc-details'+document?.id}}" aria-label="doc-details" tooltipPosition="top"
                    icon="fas fa-times"></button> -->
                    <button *ngIf="buttonConfig?.showTicketLogButton" pButton (click)="onTicketLogClick($event, document)" type="button"  [disabled]="!document?.view_ticket"
                        class="p-button-text action-button" pTooltip="Ticket Logs" icon="fas fa-file-alt" aria-label="doc-details"></button>
                    <img *ngIf="buttonConfig?.showApprovalLogButton" tooltipPosition="top" (click)="onClickApprovalLog($event, document)" pTooltip="Approval Logs"
                        class="cursor-pointer mx-1" style="width:17% !important" alt="preview-doc" src='../../../../../../assets/layout/file-icons/approved.svg'>
                <button (click)="onClickViewConfig(document)"
                    *ngIf="document?.type=='MultiSelect' || document?.type=='Radio Button' || document?.type=='Dropdown' "
                    pButton type="button" class="p-button-text action-button" pTooltip="Config Field Options"
                    id="{{'doc-details'+document?.id}}" aria-label="doc-details" tooltipPosition="top"
                    icon="fas fa-cog"></button>
                <img *ngIf="document?.is_locked" class="editIcon"
                                pTooltip="This Document is currently locked and being edited by {{document?.modified_by}}"
                                src="../../../../../assets/layout/images/document-lock.gif" alt="editing">
            </td>
            <td [ngStyle]="{'min-width': col?.width + 'px'}" *ngFor="let col of grid_schema">
                <div [ngSwitch]="col?.key">
                    <span [ngStyle]="{
                        'white-space': 'nowrap',
                        'text-overflow': 'ellipsis',
                        'overflow': 'hidden',
                        'width': col?.width ? col.width + 'px' : '180px',
                        'display': 'block',
                        'padding-right': '3px'
                      }" *ngSwitchDefault [pTooltip]="document?.[col.key]" tooltipPosition="left">{{document?.[col.key]}}</span>
                    <span *ngSwitchCase="'status'" [ngStyle]="{
                        'white-space': 'nowrap',
                        'text-overflow': 'ellipsis',
                        'overflow': 'hidden',
                        'width': col?.width ? col.width + 'px' : '180px',
                        'display': 'block',
                        'padding-right': '3px'
                      }" [pTooltip]="document?.status_name">
                        <p class="status-badge  {{ getStatusClass(document?.status_name) }}">{{document?.status_name}}</p>
                    </span>
<ng-container *ngSwitchCase="'expires_on'">
<span *ngIf="isUnderGpInvestigation(document); else gridStageTimer"
      class="rounded px-2 py-1 font-medium block bg-yellow-200 text-yellow-800"
      [style.width]="col?.width ? col.width + 'px' : '180px'"
      style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
      pTooltip="Under Group Procurement Investigation">
  Under Group Procurement Investigation
</span>
<ng-template #gridStageTimer>
<span
      [ngClass]="{
        'bg-yellow-200 text-yellow-800': isNotExpired(document?.expires_on)
      }"
      class="rounded px-2 py-1 font-medium block"
      [style.width]="col?.width ? col.width + 'px' : '180px'"
       style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
      [pTooltip]="document?.expires_on | timer | async">

  {{ document?.expires_on | timer | async }}
</span>
</ng-template>
</ng-container>

                    <span *ngSwitchCase="'ticket_status'" [ngStyle]="{
                        'white-space': 'nowrap',
                        'text-overflow': 'ellipsis',
                        'overflow': 'hidden',
                        'width': col?.width ? col.width + 'px' : '180px',
                        'display': 'block',
                        'padding-right': '3px'
                      }" [pTooltip]="document?.ticket_status_name">
                        <p class="status-badge  {{ getStatusClass(document?.ticket_status_name) }}">{{document?.ticket_status_name}}</p>
                    </span>
                    <span *ngSwitchCase="'current_status'" [ngStyle]="{
                        'white-space': 'nowrap',
                        'text-overflow': 'ellipsis',
                        'overflow': 'hidden',
                        'width': col?.width ? col.width + 'px' : '180px',
                        'display': 'block',
                        'padding-right': '3px'
                      }" [pTooltip]="document?.current_status_name">
                        <p class="status-badge  {{ getStatusClass(document?.current_status_name) }}">{{document?.current_status_name}}</p>
                    </span>
                    <span *ngSwitchCase="'is_active'">
                        <span *ngIf="document['is_active']==1">
                            <p class="status-badge active">Active</p>
                        </span>
                        <span *ngIf="document['is_active']==0">
                            <p class="status-badge inactive">Inactive</p>
                        </span>
                    </span>
                      <span *ngSwitchCase="'ticket_type'">
                        {{document?.ticket_type_name}}
                    </span>
                    <span *ngSwitchCase="'email_type_id'">
                        {{document?.email_type_label}}
                    </span>
                    <span *ngSwitchCase="'is_shared'">
                        <span *ngIf="document['is_shared']==true">
                            <p>Public</p>
                        </span>
                        <span *ngIf="document['is_shared']==false">
                            <p>Private</p>
                        </span>
                    </span>
                    <!-- <span *ngSwitchCase="'status'">
                        {{document?.status_name}}
                    </span> -->
                    <span *ngSwitchCase="'approval_required'">
                        <span *ngIf="document['approval_required']==true">
                            <p>Yes</p>
                        </span>
                        <span *ngIf="document['approval_required']==false">
                            <p>No</p>
                        </span>
                    </span>
                    <span *ngSwitchCase="'shared_between_systems'">
                        <span *ngIf="document['shared_between_systems']==true">
                            <p>Yes</p>
                        </span>
                        <span *ngIf="document['shared_between_systems']==false">
                            <p>No</p>
                        </span>
                    </span>
                    <span *ngSwitchCase="'is_transport'">
                        <span *ngIf="document['is_transport']==true">
                            <p>Yes</p>
                        </span>
                        <span *ngIf="document['is_transport']==false">
                            <p>No</p>
                        </span>
                    </span>
                    <span *ngSwitchCase="'included_in_script'">
                        <span *ngIf="document['included_in_script']==true">
                            <p>Yes</p>
                        </span>
                        <span *ngIf="document['included_in_script']==false">
                            <p>No</p>
                        </span>
                    </span>
                    <span *ngSwitchCase="'is_auto_invoicing'">
                        <span *ngIf="document['is_auto_invoicing']==true">
                            <p>Yes</p>
                        </span>
                        <span *ngIf="document['is_auto_invoicing']==false">
                            <p>No</p>
                        </span>
                    </span>
                    <span *ngSwitchCase="'is_allow_invoicing'">
                        <span *ngIf="document['is_allow_invoicing']==true">
                            <p>Yes</p>
                        </span>
                        <span *ngIf="document['is_allow_invoicing']==false">
                            <p>No</p>
                        </span>
                    </span>
                    <span *ngSwitchCase="'is_generate_doc_for_prev_period'">
                        <span *ngIf="document['is_generate_doc_for_prev_period']==true">
                            <p>Yes</p>
                        </span>
                        <span *ngIf="document['is_generate_doc_for_prev_period']==false">
                            <p>No</p>
                        </span>
                    </span>
                    <span *ngSwitchCase="'credit'">
                        <span *ngIf="document['credit']==true">
                            <p>Yes</p>
                        </span>
                        <span *ngIf="document['credit']==false">
                            <p>No</p>
                        </span>
                    </span>
                    <span *ngSwitchCase="'is_generate_separate_for_prev_period'">
                        <span *ngIf="document['is_generate_separate_for_prev_period']==true">
                            <p>Yes</p>
                        </span>
                        <span *ngIf="document['is_generate_separate_for_prev_period']==false">
                            <p>No</p>
                        </span>
                    </span>
                    <span *ngSwitchCase="'is_credit_debit_line_separate'">
                        <span *ngIf="document['is_credit_debit_line_separate']==true">
                            <p>Yes</p>
                        </span>
                        <span *ngIf="document['is_credit_debit_line_separate']==false">
                            <p>No</p>
                        </span>
                    </span>
                    <span *ngSwitchCase="'is_pod_required'">
                        <span *ngIf="document['is_pod_required']==true">
                            <p>Yes</p>
                        </span>
                        <span *ngIf="document['is_pod_required']==false">
                            <p>No</p>
                        </span>
                    </span>
                    <span *ngSwitchCase="'is_hard_copy_required'">
                        <span *ngIf="document['is_hard_copy_required']==true">
                            <p>Yes</p>
                        </span>
                        <span *ngIf="document['is_hard_copy_required']==false">
                            <p>No</p>
                        </span>
                    </span>
                    <span *ngSwitchCase="'is_pod_awaiting'">
                        <span *ngIf="document['is_pod_awaiting']==true">
                            <p>Yes</p>
                        </span>
                        <span *ngIf="document['is_pod_awaiting']==false">
                            <p>No</p>
                        </span>
                    </span>
                    <span *ngSwitchCase="'email_required'">
                        <span *ngIf="document['email_required']==true">
                            <p>Yes</p>
                        </span>
                        <span *ngIf="document['email_required']==false">
                            <p>No</p>
                        </span>
                    </span>
                    <span *ngSwitchCase="'required'">
                        <span *ngIf="document['required']==1">
                            YES
                        </span>
                        <span *ngIf="document['required']==0">
                           NO
                        </span>
                    </span>
                    <span *ngSwitchCase="'is_editable'">
                        <span *ngIf="document['is_editable']==true">
                            YES
                        </span>
                        <span *ngIf="document['is_editable']==false">
                           NO
                        </span>
                    </span>
                    <span *ngSwitchCase="'show_price_on_po'">
                        <span *ngIf="document['show_price_on_po']==true">
                            YES
                        </span>
                        <span *ngIf="document['show_price_on_po']==false">
                           NO
                        </span>
                    </span>
                    <span *ngSwitchCase="'generate_separate_documents'">
                        <span *ngIf="document['generate_separate_documents']==true">
                            YES
                        </span>
                        <span *ngIf="document['generate_separate_documents']==false">
                           NO
                        </span>
                    </span>
                    <span *ngSwitchCase="'automatic_invoicing'">
                        <span *ngIf="document['automatic_invoicing']==true">
                            YES
                        </span>
                        <span *ngIf="document['automatic_invoicing']==false">
                           NO
                        </span>
                    </span>
                    <span *ngSwitchCase="'pod_required_velocity'">
                        <span *ngIf="document['pod_required_velocity']==true">
                            YES
                        </span>
                        <span *ngIf="document['pod_required_velocity']==false">
                           NO
                        </span>
                    </span>
                    <span *ngSwitchCase="'hardcopy_required'">
                        <span *ngIf="document['hardcopy_required']==true">
                            YES
                        </span>
                        <span *ngIf="document['hardcopy_required']==false">
                           NO
                        </span>
                    </span>
                    <span *ngSwitchCase="'allow_invoicing_if_awaiting_pods'">
                        <span *ngIf="document['allow_invoicing_if_awaiting_pods']==true">
                            YES
                        </span>
                        <span *ngIf="document['allow_invoicing_if_awaiting_pods']==false">
                           NO
                        </span>
                    </span>
                    <span *ngSwitchCase="'active'">
                        <span *ngIf="document['active']==true">
                            YES
                        </span>
                        <span *ngIf="document['active']==false">
                           NO
                        </span>
                    </span>
                    <span *ngSwitchCase="'inactive'">
                        <span *ngIf="document['inactive']==true">
                            YES
                        </span>
                        <span *ngIf="document['inactive']==false">
                           NO
                        </span>
                    </span>
                    <span *ngSwitchCase="'vendor_hold'">
                        <span *ngIf="document['vendor_hold']==true">
                            <p class="status-badge inactive">Inactive</p>
                        </span>
                        <span *ngIf="document['vendor_hold']==false">
                            <p class="status-badge active">Active</p>
                        </span>
                    </span>
                    <!-- <span *ngSwitchCase="'priority'">
                        <span *ngIf="document['priority']==1">
                            <p>High</p>
                        </span>
                        <span *ngIf="document['priority']==2">
                            <p>Medium</p>
                        </span>
                        <span *ngIf="document['priority']==3">
                            <p>Low</p>
                        </span>
                    </span> -->
                    <span *ngSwitchCase="'source_file'">
                        <a class="cursor-pointer"
                        (click)="onClickDownloadUploadedFile(document?.doc_uuid)"
                        pTooltip="Download" tooltipPosition="top">
                        <i class="far fa-file-download"></i>
                    </a>
                    </span>
                    <span *ngSwitchCase="'version_flag'">
                        <span *ngIf="document['version_flag']==true">
                            YES
                        </span>
                        <span *ngIf="document['version_flag']==false">
                           NO
                        </span>
                    </span>
                    <span *ngSwitchCase="'is_standard_account'">
                        <span *ngIf="document['is_standard_account']==true">
                            YES
                        </span>
                        <span *ngIf="document['is_standard_account']==false">
                           NO
                        </span>
                    </span>
                    <span *ngSwitchCase="'is_code_of_conduct_accepted'">
                        <span *ngIf="document['is_code_of_conduct_accepted']==true">
                            YES
                        </span>
                        <span *ngIf="document['is_code_of_conduct_accepted']==false">
                           NO
                        </span>
                    </span>
                    <span *ngSwitchCase="'blocked'">
                        <span *ngIf="document['blocked']==true">
                            YES
                        </span>
                        <span *ngIf="document['blocked']==false">
                           NO
                        </span>
                    </span>
                    <span *ngSwitchCase="'is_subscribed'">
                        <span *ngIf="document['is_subscribed']==true">
                            YES
                        </span>
                        <span *ngIf="document['is_subscribed']==false">
                           NO
                        </span>
                    </span>

                    <span [ngStyle]="{
                        'white-space': 'nowrap',
                        'text-overflow': 'ellipsis',
                        'overflow': 'hidden',
                        'width': col?.width ? col.width + 'px' : '180px',
                        'display': 'block',
                        'padding-right': '3px'
                      }" *ngSwitchCase="'long_desc'">
                        <span [pTooltip]="document?.description">{{document?.description}}</span>
                    </span>
                    <span *ngSwitchCase="'privilege_names'">
                        <a class="cursor-pointer p-button-rounded p-button-success" pTooltip="View Role Privileges"   (click)="onClickViewPrivileges(document)" tooltipPosition="top">View Privilege</a>
                    </span>
                    <span *ngSwitchCase="'payload'" class="cursor-pointer">
                        <a class="p-button-rounded p-button-success" pTooltip="Payload" tooltipPosition="top"
                            (click)="onClickPayloadIcon(document?.payload)"><i class="fas fa-file"></i></a>
                    </span>
                    <span *ngSwitchCase="'file_path'">
                        <a class="p-button-rounded p-button-success" pTooltip="Download File" tooltipPosition="top"
                            (click)="downloadD365File(document?.file_name)" style="cursor: pointer; display: inline-block;">
                            <i class="fas fa-download"></i>
                        </a>
                    </span>
                    <span *ngSwitchCase="'has_sertica_contacts'">
        <span pTooltip="{{ document?.has_sertica_contacts ? 'View Sertica Contacts' : 'No Data' }}" tooltipPosition="top">
            <a class="p-button-rounded"
                [ngClass]="document?.has_sertica_contacts ? 'p-button-success' : 'p-button-secondary p-disabled'"
                (click)="document?.has_sertica_contacts && onClickSerticaContacts(document)" [attr.aria-disabled]="!document?.has_sertica_contacts"
                [attr.tabindex]="document?.has_sertica_contacts ? '0' : '-1'">
               <i class="fas fa-address-book"></i>
            </a>
        </span>
    </span>
                   <span *ngSwitchCase="'has_contact'">
    <span pTooltip="{{ document?.has_contact ? 'View Contacts' : 'No Data' }}" tooltipPosition="top">
        <a class="p-button-rounded" [ngClass]="document?.has_contact ? 'p-button-success' : 'p-button-secondary p-disabled'"
            (click)="document?.has_contact && onClickContacts(document)" [attr.aria-disabled]="!document?.has_contact"
            [attr.tabindex]="document?.has_contact ? '0' : '-1'">
            <i class="fas fa-user-friends"></i>
        </a>
    </span>
    </span>
    <span *ngSwitchCase="'has_address'">
        <span pTooltip="{{ document?.has_address ? 'View Address' : 'No Data' }}" tooltipPosition="top">
            <a class="p-button-rounded"
                [ngClass]="document?.has_address ? 'p-button-success' : 'p-button-secondary p-disabled'"
                (click)="document?.has_address && onClickAddress(document)" [attr.aria-disabled]="!document?.has_address"
                [attr.tabindex]="document?.has_address ? '0' : '-1'">
                <i class="fas fa-map-marker-alt"></i>
            </a>
        </span>
    </span>
<span *ngSwitchCase="'has_bank'">
    <span pTooltip="{{ (document?.view_ssc_privilege && document?.has_bank) ? 'View Bank Details' : 'No Data' }}"
        tooltipPosition="top">
        <a class="p-button-rounded" [ngClass]="
          (document?.view_ssc_privilege && document?.has_bank)
            ? 'p-button-success'
            : 'p-button-secondary p-disabled'
       " (click)="document?.view_ssc_privilege && document?.has_bank && onClickBankDetails(document)"
            [attr.aria-disabled]="!(document?.view_ssc_privilege && document?.has_bank)"
            [attr.tabindex]="(document?.view_ssc_privilege && document?.has_bank) ? '0' : '-1'">
            <i class="fas fa-university"></i>
        </a>
    </span>
</span>
                    <span *ngSwitchCase="'file_name'">
                        <a class="p-button-rounded p-button-success" pTooltip="View File" tooltipPosition="top"
                            (click)="onDownload(document)" style="cursor: pointer; display: inline-block;">
                            <i class="fas fa-file"></i>
                        </a>
                    </span>
                    <!-- <span *ngSwitchCase="'file_available'" class="cursor-pointer">
                        <a *ngIf="document.file_available"
                            (click)="onClickDownloadAttachment(document.file_content,document?.short_desc)"
                            pTooltip="Download Attachment" tooltipPosition="top">
                            <i class="fas fa-download"></i>
                        </a> </span> -->
                        <span *ngSwitchCase="'file_available'" class="cursor-pointer">
                            <a *ngIf="document.file_available"
                               (click)="onClickDownloadAttachment(document?.id, document?.short_desc)"
                               pTooltip="Download Attachment" tooltipPosition="top">
                              <i class="fas fa-download"></i>
                            </a>
                          </span>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="12">No Data found.</td>
        </tr>
    </ng-template>
</p-table>
<p-paginator #paginator (onPageChange)="paginate($event)" [rows]="page_size" [showCurrentPageReport]="true"
    class="pageRow" [templateRight]="templateRight"
    currentPageReportTemplate="Showing  {first} to {last} of {{total_records}} Records {{date_range}} "
    [totalRecords]="total_records" [rowsPerPageOptions]="page_size_list">
</p-paginator>
<!-- <p-speedDial tooltip="Config" [model]="items" [mask]="true" direction="up" [transitionDelay]="80" showIcon="pi pi-bars" hideIcon="pi pi-times" buttonClassName="p-button-outlined"></p-speedDial> -->
<ng-template #templateRight>
    <span class="flex w-full paginator-goto">
        <input pInputText [(ngModel)]="jumpToPageNo" (keyup.enter)="jumpToPage($event)" type="number"
            placeholder="Go To Page"
            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"></span>
</ng-template>
<a class="float" *ngIf="buttonConfig?.showAddButton" pTooltip="Add" tooltipPosition="top"
    (click)="onClickAddUpdateModal()"><i class="fa fa-plus my-float"></i></a>

<p-toast position="top-center"></p-toast>

<p-dialog [(visible)]="showColumnSettingsModal" header="Column Settings" styleClass="w-5" [closable]="true" [modal]="true"
[draggable]="false" [resizable]="false" (onHide)="onHideColumnSettings()">
    <p-table [columns]="user_schema" [value]="user_schema" [reorderableColumns]="true" [resizableColumns]="true"
    [scrollable]="true" scrollHeight="395px" scrollDirection="vertical">
    <ng-template pTemplate="caption">
        <div class="table-header" class="flex justify-content-end">
            <button pButton type="button" icon="pi pi-plus" label="RESET"
              class="mr-2 cozmos-secondary-button" (click)="onClickResetColumnSettings()"></button>
            <button pButton type="button" label="SAVE" class="mr-2 cozmos-primary-button" (click)="onClickSaveColumnSettings()"></button>
        </div>
      </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr class="block">
            <th class="reorder-col bg-white pb-2 pt-2" *ngFor="let col of columns; let i = index;"
                pReorderableColumn [pReorderableColumnDisabled]="col?.is_disabled" pResizableColumn>
                <span class="mr-3" style="width:15px;">{{i+1}}.</span>
                <span *ngIf="!col?.is_disabled" class="mr-4">
                    <p-checkbox [binary]="true" inputId="binary" [(ngModel)]="col.is_selected"></p-checkbox>
                </span>
                <span *ngIf="!col.disabled" class="pi pi-bars mr-3"></span>
                <span class="ml-3">{{col?.label}}</span>
            </th>
        </tr>
    </ng-template>
</p-table>
</p-dialog>

    <p-overlayPanel #vendorMapDataToggle [showCloseIcon]="true" [dismissable]="true">
        <ng-template pTemplate>
            <span class="mt-2">
                         <p-table [columns]="masterDataGridSchema" [value]="vendorMapData"
                tableStyleClass="min-h-0"
                styleClass="errorTableBox min-h-0 relative z-0 p-datatable-sm p-datatable-gridlines">
                 <ng-template pTemplate="caption">
                        <span class="flex justify-content-end align-items-center">
                            <b>Supplier Map Data</b>
                        </span>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th class="action">Actions</th>
                        <th *ngFor="let col of columns" class="errorTable">
                            {{col.header}}
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <td>
                            <button pButton type="button"
                             class="p-button-text action-button" pTooltip="View Source System"
                            id="{{'doc-details'+rowData?.id}}" (click)="onClickViewSourceSystem(rowData)" tooltipPosition="top" icon="fas fa-share"></button>
                        </td>
                        <td *ngFor="let col of columns" class="errorTable">
                            <div [ngSwitch]="col?.field">
                                <span *ngSwitchCase="'receivedOn'"
                                    [ngClass]="rowData?.status?'error-message green':'error-message brown'">
                                    <span>{{rowData?.['receivedOn']?(rowData?.['receivedOn'] | date):''}}</span>
                                </span>
                                    <span *ngSwitchDefault>
                                    {{rowData[col.field]}}</span>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="5">No Data Found.</td>
                    </tr>
                </ng-template>
            </p-table>
            </span>
        </ng-template>
    </p-overlayPanel>
